module.exports = __webpack_public_path__ + "static/img/level-card-banner2.6b3ce66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/4/level-card-banner2.png
// module id = hqwn
// module chunks = 1